import { NodeViewProps } from '@tiptap/core';
import CodeBlockLowlight from '@tiptap/extension-code-block-lowlight';
import { NodeViewContent, NodeViewWrapper } from '@tiptap/react';
import { Check, ChevronDown } from 'lucide-react';
import React from 'react';
import { Command, Popover } from 'ui/components';
import { cn } from 'utils/cn';

interface CodeBlockComponentProps extends NodeViewProps {
  extension: typeof CodeBlockLowlight;
}

const CodeBlockComponent: React.FC<CodeBlockComponentProps> = ({
  node,
  updateAttributes,
  extension,
  editor,
}) => {
  const language = node.attrs.language || 'null';
  const languages = ['null', ...extension.options.lowlight.listLanguages()];

  return (
    <NodeViewWrapper className="code-block relative">
      <Popover>
        <Popover.Trigger asChild>
          {editor.isEditable && (
            <button className="absolute right-0 top-0 flex items-center gap-2 rounded-md border bg-background px-3 py-1.5 text-sm">
              {language === 'null' ? 'auto' : language}
              <ChevronDown className="ml-2 h-4 w-4" />
            </button>
          )}
        </Popover.Trigger>
        <Popover.Content className="w-[200px] p-0" align="start">
          <Command>
            <Command.Input placeholder="Search language..." />
            <Command.List>
              <Command.Empty>No language found.</Command.Empty>
              <Command.Group>
                {languages.map((lang) => {
                  const isSelected = lang === language;
                  return (
                    <Command.Item
                      key={lang}
                      onSelect={() => {
                        updateAttributes({ language: lang });
                      }}
                    >
                      <div
                        className={cn(
                          'border-primary mr-2 flex h-4 w-4 items-center justify-center rounded-sm border',
                          isSelected
                            ? 'bg-primary text-primary-foreground'
                            : 'opacity-50 [&_svg]:invisible'
                        )}
                      >
                        <Check className={cn('h-4 w-4')} />
                      </div>
                      <span>{lang === 'null' ? 'auto' : lang}</span>
                    </Command.Item>
                  );
                })}
              </Command.Group>
            </Command.List>
          </Command>
        </Popover.Content>
      </Popover>
      <pre>
        <NodeViewContent as="code" />
      </pre>
    </NodeViewWrapper>
  );
};

export default CodeBlockComponent;
